// The designer's reference viewport, so the layout spec's coordinates are
// literal canvas pixels rather than something we have to convert.
export const gameConfig = {
  canvasSize: { width: 1440, height: 900 },
  aspectRatio: 1440 / 900, // 1.6
};
